import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ClinicBrandingProvider } from "./context/ClinicBrandingContext";
import { Header, Footer } from "./components/Layout";
import { Toaster } from "./components/ui/sonner";

// Public Pages
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import BookingPage from "./pages/BookingPage";
import ReviewsPage from "./pages/ReviewsPage";
import ContactPage from "./pages/ContactPage";

// Admin Pages
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminLayout from "./pages/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import AdminProducts from "./pages/AdminProducts";
import AdminAppointments from "./pages/AdminAppointments";
import AdminPendingAppointments from "./pages/AdminPendingAppointments";
import AdminReviews from "./pages/AdminReviews";
import AdminSchedule from "./pages/AdminSchedule";
import AdminWhatsApp from "./pages/AdminWhatsApp";
import AdminSettings from "./pages/AdminSettings";
import AdminSitePublic from "./pages/AdminSitePublic";
import AdminManageAdmins from "./pages/AdminManageAdmins";
import AdminPatientRecords from "./pages/AdminPatientRecords";
import AdminPatientRecordDetail from "./pages/AdminPatientRecordDetail";
import AdminClinicalEncounter from "./pages/AdminClinicalEncounter";
import AdminConsentPreview from "./pages/AdminConsentPreview";
import AdminEvolutionNotePreview from "./pages/AdminEvolutionNotePreview";

// Public Layout Component
function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <ClinicBrandingProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
            <Route path="/productos" element={<PublicLayout><ProductsPage /></PublicLayout>} />
            <Route path="/agendar" element={<PublicLayout><BookingPage /></PublicLayout>} />
            <Route path="/resenas" element={<PublicLayout><ReviewsPage /></PublicLayout>} />
            <Route path="/contacto" element={<PublicLayout><ContactPage /></PublicLayout>} />
            
            {/* Admin Login */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/nota-evolucion-preview" element={<AdminEvolutionNotePreview />} />
            <Route path="/admin/consentimiento-preview" element={<AdminConsentPreview />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="productos" element={<AdminProducts />} />
              <Route path="citas/por-confirmar" element={<AdminPendingAppointments />} />
              <Route path="citas" element={<AdminAppointments />} />
              <Route path="expedientes" element={<AdminPatientRecords />} />
              <Route path="expedientes/:recordId" element={<AdminPatientRecordDetail />} />
              <Route path="expedientes/:recordId/encuentro/:encounterId" element={<AdminClinicalEncounter />} />
              <Route path="resenas" element={<AdminReviews />} />
              <Route path="horarios" element={<AdminSchedule />} />
              <Route path="whatsapp" element={<AdminWhatsApp />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="sitio-publico" element={<AdminSitePublic />} />
              <Route path="administradores" element={<AdminManageAdmins />} />
            </Route>
          </Routes>
          </ClinicBrandingProvider>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </div>
    </AuthProvider>
  );
}

export default App;
